import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: "AIzaSyAQsMagtf2CUC0Ucakcgx26sroPgL3FbEs",
  authDomain: "easylife-d9070.firebaseapp.com",
  databaseURL: "https://easylife-d9070-default-rtdb.firebaseio.com",
  projectId: "easylife-d9070",
  storageBucket: "easylife-d9070.appspot.com",
  messagingSenderId: "922312304870",
  appId: "1:922312304870:web:094d081185bc37c6d9f327",
  measurementId: "G-CSYEK90RM8",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
